import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { normalize } from '@acme/common'
import { Maybe } from '@acme/core'
import { Typography } from '@mui/material'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { Alteracao } from 'service/api'

interface IProps {
    value: Alteracao
}

const columns: GridColDefPro[] = [
    {
        field: 'key',
        headerName: 'Campo',
        flex: 1,
    },
    {
        field: 'value',
        headerName: 'Valor',
        flex: 1,
    },
]

export default function TabObjetoAtual({ value }: IProps) {
    const obj = Maybe.from(value.modulo).map(
            modulo => (value as any)[normalize(modulo)],
        ),
        rows = Object.entries(obj ?? {}).map(([key, value], id) => ({
            key,
            value: parseValue(value),
            id,
        }))

    if (!rows.length) return <Typography>Nenhum dado encontrado</Typography>

    return (
        <ContentGuide.DataGrid
            loading={false}
            columns={columns}
            rows={rows}
            hideFooter
            headerHeight={0}
            ToolbarProps={{ hideToolbar: true }}
            rowHeight={40}
        />
    )
}

function parseValue(value: any): string {
    value = String(value).trim()
    if (value === 'null' || value === 'undefined') return ''
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value)) {
        return dayjs.utc(value).format('DD/MM/YYYY HH:mm:ss z')
    }
    if (value.startsWith('[object Object]')) {
        return '*Formato não suportado'
    }
    return value
}
